/*
 * Public API Surface of microapp
 */
export * from './lib/microapp-notifications.module';
export * from './pages/microapp-notifications.home.component';
export * from './pages/microapp-notifications.module';
